/* ------------------------------------*\
    VARIABLE DECLARATION
\*------------------------------------*/

$(window).on('load', () => {
    /*------------------------------------*\
        CALL TO FUNCTIONS
    \*------------------------------------*/


    if (isCart()) {
        // console.log(
        //     '<!-- ----------------------------------------------------- -->\n' +
        //     '<!-- CART -->\n' +
        //     '<!-- ----------------------------------------------------- -->');
        setupCartUpdateQantity();
    } else if(isAccountPage()){
        //
        setupAccountSection();
    }

});

/*------------------------------------*\
HOME
\*------------------------------------*/
function setupCartUpdateQantity(){
    $( 'div.woocommerce' ).on( 'change', 'input.qty', function() {
        $("[name='update_cart']").removeAttr( 'disabled' );
        $("[name='update_cart']").trigger("click");
    });
}

function setupAccountSection(){
    if(deviceDetector.device == 'desktop'){
        // You're on a desktop.
        // console.log('desktop');
    }else{
        setupMobileNavigationInAccount();

        if(deviceDetector.device == 'tablet'){
            // You're on a tablet.
            // console.log('tablet');
        }else{
            // console.log('phone');
        }
        // You're on a phone.
    }
}

/*------------------------------------*\
Account
\*------------------------------------*/
function setupMobileNavigationInAccount(){
    const $nav_toggle = $('#header-user-info-name-mobile-toggle');
    const $nav_conteiner = $('.wc-myaccount-nav');

    if($('body').hasClass('is_my_account_page')){
        $nav_toggle.toggleClass('active');
        $nav_conteiner.toggleClass('active');

    }else{
        $nav_toggle.on('click',function(){
            $nav_toggle.toggleClass('active');
            $nav_conteiner.toggleClass('active');
        });
    }
}

/*------------------------------------*\
NEWSLETTER FORM
\*------------------------------------*/


/*------------------------------------*\
jQuery Events
\*------------------------------------*/
$(window).on('scroll', function () {

});


/*------------------------------------*\
Extra methods
\*------------------------------------*/
